import React from 'react';

interface Props {
    className?: string;
    width?: string | number;
    height?: string | number;
    color?: string;
}

const LightningBoltIcon: React.FC<Props> = ({
    className,
    width = "150", // Default width increased 1.5x
    height = "300", // Default height increased 1.5x
    color = "#000000" // Default black color
}) => {
    // Using points derived from the SVG editor with background template
    const points = "14,10 39,10 28,30 49,30 -8,94 13,47 -5,47";

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 50 100" // ViewBox defines the coordinate system
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet" // Adjust aspect ratio handling if needed
        >
            <polygon points={points} fill={color} />
        </svg>
    );
};

export default LightningBoltIcon; 